module.exports = __webpack_public_path__ + "static/img/7065216.a51af5ed.png";